import api from './api';

const timesheetApprovalService = {
  // Get all timesheet approvals
  getAllTimesheetApprovals: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.employeeId) queryParams.append('employeeId', params.employeeId);
      if (params.approverId) queryParams.append('approverId', params.approverId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.priority) queryParams.append('priority', params.priority);

      const queryString = queryParams.toString();
      const url = `/timesheet-approval${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching timesheet approvals:', error);
      throw error;
    }
  },

  // Get timesheet approval by ID
  getTimesheetApprovalById: async (id) => {
    try {
      const response = await api.get(`/timesheet-approval/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching timesheet approval:', error);
      throw error;
    }
  },

  // Get next approval number
  getNextApprovalNumber: async () => {
    try {
      const response = await api.get('/timesheet-approval/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next approval number:', error);
      throw error;
    }
  },

  // Create timesheet approval
  createTimesheetApproval: async (approvalData) => {
    try {
      const response = await api.post('/timesheet-approval', approvalData);
      return response.data;
    } catch (error) {
      console.error('Error creating timesheet approval:', error);
      throw error;
    }
  },

  // Approve timesheet
  approveTimesheet: async (id, approvalNotes, itemApprovals) => {
    try {
      const response = await api.put(`/timesheet-approval/${id}/approve`, {
        approvalNotes,
        itemApprovals
      });
      return response.data;
    } catch (error) {
      console.error('Error approving timesheet:', error);
      throw error;
    }
  },

  // Reject timesheet
  rejectTimesheet: async (id, rejectionReason, itemApprovals) => {
    try {
      const response = await api.put(`/timesheet-approval/${id}/reject`, {
        rejectionReason,
        itemApprovals
      });
      return response.data;
    } catch (error) {
      console.error('Error rejecting timesheet:', error);
      throw error;
    }
  },

  // Return timesheet for revision
  returnTimesheet: async (id, notes) => {
    try {
      const response = await api.put(`/timesheet-approval/${id}/return`, { notes });
      return response.data;
    } catch (error) {
      console.error('Error returning timesheet:', error);
      throw error;
    }
  },

  // Get timesheet approval statistics
  getTimesheetApprovalStats: async () => {
    try {
      const response = await api.get('/timesheet-approval/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching timesheet approval statistics:', error);
      throw error;
    }
  }
};

export default timesheetApprovalService;

